import React, { useEffect, useRef } from 'react';

import { focusRef } from '../../../crm/shared/field_inputs/shared/EventHelpers';

const parseValue = (s) => {
    if (!s || !s.length) {
        return null;
    } else if (isNaN(s.replace(',', '.'))) {
        return NaN;
    } else {
        return parseFloat(s.replace(',', '.'));
    }
};
const ExlEditNumber = ({ value, setValue, onKeyDown, isInvalid, autoFocus, placeholder }) => {

    const inputRef = useRef();

    const onChange = (e) => {
        if (isNaN(e.target.value)) { return NaN }
        setValue(e.target.value);
    }
    useEffect(() => {
        autoFocus && focusRef(inputRef);
        if (value === undefined || value === null) {
            setValue('');
        }
        
    }, []);

    return (
        <div className='crm-editable-field-wrapper'>
            <input
                ref={inputRef}
                className={`text-input ${isInvalid ? 'invalid' : ''}`}
                value={value ?? ''}
                onKeyDown={onKeyDown}
                placeholder={placeholder }
                onChange={(e) => onChange(e)}
            />
        </div>
    );
};

export default ExlEditNumber;
